import styled from 'styled-components'

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const MenuContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
`
